import { fetchData } from "app/services/apiService";

const accessHeaders = (accessToken) => ({
  "X-Opzioni-Access-Token": accessToken,
});

export const sbloccaOpzioni = (password) => (dispatch) =>
  dispatch(fetchData("OpzioniAccess/Sblocca", { password }, null, "POST"));

export const caricaOpzioniProtette = (accessToken) => (dispatch) =>
  dispatch(fetchData(
    "VariabiliStrutture/ElencoOpzioni", null, null, "GET", undefined, accessHeaders(accessToken)
  ));

export const salvaOpzioniProtette = (variabili, accessToken) => (dispatch) =>
  dispatch(fetchData(
    "VariabiliStrutture/SalvaMulti", variabili, null, "POST", undefined, accessHeaders(accessToken)
  ));
